import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "bg-gray-100" }
const _hoisted_3 = { class: "max-w-7xl mx-auto sm:px-6 lg:px-8 pt-8" }
const _hoisted_4 = { class: "text-xl md:text-4xl font-extrabold tracking-tight text-black text-center" }
const _hoisted_5 = { class: "px-4 py-8 sm:px-0" }
const _hoisted_6 = { class: "max-w-7xl mx-auto sm:px-6 lg:px-8" }
const _hoisted_7 = { class: "px-4 py-8 sm:px-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "sm:flex sm:items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sm:flex-auto" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold text-gray-900" }, "New Requests"),
    /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm text-gray-700" }, " A list of new and updated orders. Please confirm each item to acknowledge the new request. ")
  ])
], -1)
const _hoisted_9 = { class: "mt-8 flex flex-col" }
const _hoisted_10 = { class: "px-4 py-8 sm:px-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "sm:flex sm:items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sm:flex-auto" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold text-gray-900" }, " Waiting To Ship "),
    /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm text-gray-700" }, " A list of orders waiting to be shipped to JC Jewels. When lodging a shipment, select the items to mark as shipped, add a tracking reference and an invoice for the included orders. ")
  ])
], -1)
const _hoisted_12 = { class: "mt-8 flex flex-col" }
const _hoisted_13 = { class: "px-4 py-8 sm:px-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "sm:flex sm:items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sm:flex-auto" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold text-gray-900" }, " Orders on Hold "),
    /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-sm text-gray-700" }, " Please keep the following items available until we update their status. ")
  ])
], -1)
const _hoisted_15 = { class: "mt-8 flex flex-col" }

import UnconfirmedOrdersTable from "@/components/UnconfirmedOrdersTable.vue";
import ShippableOrdersTable from "@/components/ShippableOrdersTable.vue";
import { ref } from "@vue/reactivity";
import { IOrder } from "@/utils/IOrder";
import Button from "@/components/Button.vue";
import ShipmentModal from "@/components/ShipmentModal.vue";
import SupplierOrderStats from "@/components/SupplierOrderStats.vue";
import { useVendor } from "@/composables/vendor";
import { watch } from "@vue/runtime-core";
import { useOrders } from "@/composables/orders";
import HoldsTable from "@/components/HoldsTable.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isShipmentModalOpen = ref(false);
const selectedForShipment = ref([] as IOrder[]);
const { currentVendor } = useVendor();
const { orders } = useOrders();

watch(currentVendor, () => {
  selectedForShipment.value = [];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", null, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, " JC Jewels x " + _toDisplayString(_unref(currentVendor)?.name), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(SupplierOrderStats)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("section", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(UnconfirmedOrdersTable)
          ])
        ]),
        _createElementVNode("section", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(ShippableOrdersTable, {
              selected: selectedForShipment.value,
              "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => ((selectedForShipment).value = $event)),
              onCreateShipment: _cache[1] || (_cache[1] = ($event: any) => (isShipmentModalOpen.value = true))
            }, null, 8, ["selected"])
          ])
        ]),
        _createElementVNode("section", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createVNode(HoldsTable)
          ])
        ])
      ])
    ]),
    _createVNode(ShipmentModal, {
      open: isShipmentModalOpen.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (isShipmentModalOpen.value = false)),
      selected: selectedForShipment.value,
      "onUpdate:selected": _cache[3] || (_cache[3] = ($event: any) => ((selectedForShipment).value = $event))
    }, null, 8, ["open", "selected"])
  ]))
}
}

})